import { defineStore } from 'pinia'
import { store } from '../index'
import { getEnumApi, getDictOneApi } from '@/api/common'

const DICT_CODES = ['specialityType','positionType','refereeLevel','politicalBackground','ethnicity','unitType','language','clothSize','education']
interface CommonState {
   eunms: any,
   dicts: any
}

export const useCommonStore = defineStore('common', {
  state: (): CommonState => {
    return {
      eunms: {},
      dicts: {}
    }
  },
  getters: {
    Enums(): any {
      return this.eunms
    },
    Dicts(): any  {
      return this.dicts
    }

  },
  actions: {
    async init() {
      const result = await getEnumApi()
      this.eunms = result

      DICT_CODES.forEach(async it => {
        const data = await getDictOneApi(it)
        // this.dicts[it] = data.nodes.map(it2 => { const { code: value, name: label } = it2; return { value, label }; })
        this.dicts[it] = data.nodes
      })
    },

    getEnumList(enumType: string) {
      const anEnum = this.eunms[enumType]
      return Object.keys(anEnum).map(k => anEnum[k])
    },

    getEnumLabel(enumType: string, value: any) {
      const list = this.getEnumList(enumType) 
      return list.find(it => it.value == value)?.label
    },

    getNameFromDict(dicKey: string, value : string) {
      if(!!dicKey && !!value) {
        const list = this.dicts[dicKey]
        // return list?.find((it: any) => it.value == value || it.id == value)?.label
        return list?.find((it: any) => it.code == value || it.id == value)?.name
      }
      return ''
    },
    getNamesFromDict(dicKey: string, values : string[]) {
      if(!!dicKey && !!values) {
        const list = this.dicts[dicKey]
        // return list?.filter((it: any) => values.includes(it.value)).map(it =>it.label)?.join()
        return list?.filter((it: any) => values.includes(it.code)).map(it =>it.name)?.join()
      }
      return ''
    }
  },
  persist: true
})

export const useCommonStoreWithOut = () => {
  return useCommonStore(store)
}
